import gql from 'graphql-tag'

export default {
  GET_USERS: gql`
    query getUsers(
      $keyword: [String!]
      $page: Int
      $first: Int
      $companyId: [String!]
      $projectId: [String!]
      $includeInactive: Boolean
      $tags: [String!]
      $isOnline: Boolean
      $sortBy: UserSortType!
      $sortDirection: SortDirection!
    ) {
      users(
        first: $first
        page: $page
        user: { searchKey: NAME, keyword: $keyword }
        project: { searchKey: UUID, keyword: $projectId }
        includeInactive: $includeInactive
        sortBy:{
          type:$sortBy
          project: {searchKey: UUID, keyword: $projectId}
          direction:$sortDirection
        }
        filter: {
          projectUid: $projectId
          tag: $tags
          isOnline: $isOnline
        }
      ) {
        data {
          name
          avatar
          email
          id
          uuid
          isOnline(project: { keyword: $projectId, searchKey: UUID })
          tags(project: { keyword: $projectId, searchKey: UUID }) {
            name
            color
            id
            description
          }
          companyRoles(
            company: { searchKey: UUID, keyword: $companyId }
            first: -1
          ) {
            data {
              role {
                name
                displayName
              }
            }
          }
          projectRoles(
            project: { searchKey: UUID, keyword: $projectId }
            first: -1
            includeInactiveProjects: $includeInactive
          ) {
            data {
              role {
                name
                displayName
              }
              deactivatedAt
            }
          }
        }
        total
      }
    }
  `,
}
